import styled from 'styled-components';

import userAvatar from '../../assets/images/userAvatar.png';
import { theme } from '../ui/themes/default';

export const HeaderWrapper = styled.div`
  width: 100%;
  padding: 24px 32px 24px 40px;
  background: ${theme.paleGrey};
  display: flex;
  justify-content: space-between;
`;

export const FiltersSection = styled.div`
  display: flex;
  width: 40%;
`;

export const UserSection = styled.div`
  display: flex;
  gap: 16px;
`;

export const UserDropdownItem = styled.div`
  display: flex;
  align-items: center;
  width: 225px;
  gap: 16px;
  margin: 8px 12px;
`;

export const InputWrapper = styled.div`
  margin-right: 16px;
  height: 56px;
  width: 100%;
  min-width: 312px;
`;

export const UserAvatar = styled.div<{ imageUrl?: string; dropdownUser?: boolean }>`
  width: ${({ dropdownUser }) => (dropdownUser ? '40px' : '56px')};
  height: ${({ dropdownUser }) => (dropdownUser ? '40px' : '56px')};
  background: url(${({ imageUrl }) => imageUrl || userAvatar});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  border-radius: 50%;
  cursor: ${({ dropdownUser }) => (dropdownUser ? 'auto' : 'pointer')};
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
